import * as React from 'react';
import {BaseComponent} from '../baseComponent';
import {Translate} from '../../services/translate';
import {lazyInject} from '../../services/container';

export class Loading extends BaseComponent
{
    @lazyInject(Translate)
    private translate: Translate;

    public render(): React.ReactNode
    {
        return <div className="loading-indicator">{this.translate.translate('loading')}</div>;
    }
}